import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { withProps } from 'recompose';
import { Col, Row } from 'antd';

import s from './styles.less';

import { composeColumns } from '../../utils/plan';

const propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        render: PropTypes.func,
      }).isRequired,
    ),
  ).isRequired,
  data: PropTypes.object.isRequired,
  withHeader: PropTypes.bool,
};
const defaultProps = {
  withHeader: true,
};

const CardContent = ({ columns, data, withHeader }) => (
  <div
    className={cn({
      [s.withHeader]: withHeader,
    })}
  >
    <Row gutter={16}>
      {columns.map((column, index) => (
        <Col span={24 / columns.length} key={index}>
          {column.map(({ id, title, render }) => (
            <div className={s.info} key={id}>
              <div className={s.infoTitle}>{title}</div>
              <div className={s.infoValue}>
                {render ? render(data[id], data) : data[id] || 'Not specified'}
              </div>
            </div>
          ))}
        </Col>
      ))}
    </Row>
  </div>
);

CardContent.propTypes = propTypes;
CardContent.defaultProps = defaultProps;

export default withProps(({ fields }) => ({
  columns: composeColumns(fields),
}))(CardContent);
